<template>
    <a-list
        itemLayout="horizontal"
        :dataSource="uploadingFiles"
        :rowKey="item => item.uid"
        :locale="{
            emptyText: 'Nincsenek függőben lévő fájlok.'
        }"
    >   
        <transition
            name="file-list-transition"
            appear
            slot="renderItem" slot-scope="item"
        >
            <a-list-item 
                class="file-list-transition-item"
                :rowKey="item.uid"
                :key="item.uid"
            >
                <a-list-item-meta>
                    <span slot="title"
                        class="file-progress-title"
                    >
                        <span>{{ item.nice_name.length > 100 ? `${item.nice_name.slice(100)}...` : item.nice_name }}</span>
                        <span v-if="item.status === 'success' || item.status === 'exception'">
                            <a-tooltip
                                title="Bezár"
                                placement="leftBottom"
                            >
                                <a-icon 
                                    :style="{
                                        marginRight: '10px',
                                        cursor: 'pointer'
                                    }"
                                    type="close" 
                                    v-on:click="removeFileUpload(item.uid)"
                                />
                            </a-tooltip>
                        </span>
                    </span>
                    <span slot="description">
                        <a-progress :percent="item.progress" :status="item.status" size="small" />
                    </span>
                </a-list-item-meta>
            </a-list-item>
        </transition>
    </a-list>
</template>

<script>
import { REMOVE_UPLOADING_FILE } from '../../../store/mutation_types';

export default {
    props: {
        folderId: {
            type: String | Number
        }
    },

    computed: {
        uploadingFiles() {        
            return this.$store.getters.getUploadingFiles(this.folderId);
        }
    },

    methods: {
        removeFileUpload(fileId) {
            this.$store.commit({
                type: REMOVE_UPLOADING_FILE,
                uid: fileId
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .file-progress-title {
        display: flex;
        justify-content: space-between;
    }


    .file-list-transition-item {
        transition: all 0.2s;
    }

    .file-list-transition-enter-to {
        opacity: 1;
    }

    .file-list-transition-enter, .file-list-transition-leave-to {
        opacity: 0;
    }
</style>
